// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer--1rQIj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Footer/Footer.css
// module id = 64
// module chunks = 0